import store from "utils/store.js";

export default function setBanner(isOn) {
  store.dispatch({
    type: "banner/setVideo",
    payload: isOn,
  });
}
